import React from 'react';
import { ArrowRight, Cpu, Rocket, Blocks, Terminal } from 'lucide-react';
import './Home.css';

function Home() {
  const navigate = (path) => {
    const event = new CustomEvent('navigate', { detail: path });
    window.dispatchEvent(event);
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-badge">Innovating at the Edge</div>
        <h1 className="hero-title">
          We build the future of <br/><span className="text-gradient">Blockchain & AI</span>
        </h1>
        <p className="hero-subtitle">
          Retrorocket Labs is a premium software development studio specializing in decentralized systems, artificial intelligence, and scalable web infrastructure.
        </p>
        <div className="hero-cta-group">
          <button className="primary-btn" onClick={() => navigate('/products')}>
            View Our Products <ArrowRight size={20} />
          </button>
          <a href="mailto:hello@retrorocket.ai" className="secondary-btn">
            Get in Touch
          </a>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <h2 className="section-title">Our Capabilities</h2>
        <p className="section-subtitle">Deep technical expertise across modern technology stacks.</p>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon"><Blocks size={32} /></div>
            <h3>Blockchain Engineering</h3>
            <p>Smart contracts, DeFi protocols, and decentralized applications built for security and scale.</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><Cpu size={32} /></div>
            <h3>AI Integration</h3>
            <p>Leveraging state-of-the-art LLMs, machine learning architectures, and autonomous agents to build intelligent applications.</p>
          </div>
          <div className="service-card">
            <div className="service-icon"><Terminal size={32} /></div>
            <h3>Full-Stack Systems</h3>
            <p>Robust, high-performance web and mobile applications using modern frameworks and cloud infrastructure.</p>
          </div>
        </div>
      </section>

      {/* Featured Section */}
      <section className="featured-section">
        <div className="featured-content">
          <div className="featured-text">
            <div className="featured-badge">Featured Product</div>
            <h2 className="section-title text-left">Based</h2>
            <p className="featured-desc">
              We don't just build for clients, we build our own ambitious products. Based is our upcoming social finance application designed to revolutionize how communities interact with capital.
            </p>
            <a href="https://basedapp.com" target="_blank" rel="noopener noreferrer" className="primary-btn outline">
              Visit basedapp.com <ArrowRight size={20} />
            </a>
          </div>
          <div className="featured-visual">
            <div className="abstract-shape"></div>
            <div className="product-mockup">
               <div className="mockup-header">
                  <div className="mockup-dot"></div>
                  <div className="mockup-dot"></div>
                  <div className="mockup-dot"></div>
               </div>
               <div className="mockup-body">
                 <Rocket size={48} className="mockup-icon" />
                 <h4>Coming Soon</h4>
                 <p>iOS & Android</p>
               </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to launch your next big idea?</h2>
        <p>Partner with us to turn your complex technical vision into a shipped product.</p>
        <a href="mailto:hello@retrorocket.ai" className="primary-btn lg">
          Start a Conversation <ArrowRight size={20} />
        </a>
      </section>
    </div>
  );
}

export default Home;